import { attachPass } from "@faro-lotv/app-component-toolbox";
import { FxaaPass } from "@faro-lotv/lotv";
import { useState, type JSX } from "react";

/**
 * @returns The anti-aliasing pass of @faro-lotv/app-component-toolbox, but keeping the alpha of the
 * rendered image, so that content behind the canvas (the world map) shows through empty areas
 */
export function AlphaFxaaPass(): JSX.Element {
  const [pass] = useState(() => {
    const fxaa = new FxaaPass();
    fxaa.material.fragmentShader = fxaa.material.fragmentShader.replaceAll(
      /vec4\((rgb[AB]), 1\.0\)/g,
      "vec4($1, texture2D(uColorTex, v_rgbM).a)",
    );
    return fxaa;
  });
  return <primitive name="FxaaPass" object={pass} attach={attachPass} />;
}
